import "semantic-ui-css/semantic.min.css";
import "react-flexbox-grid/dist/react-flexbox-grid.css";
import "react-toastify/dist/ReactToastify.min.css";
import "react-tippy/dist/tippy.css";
import "../src/styles/globals.css";
import { useEffect } from "react";
import { SWRConfig } from "swr";
import Script from "next/script";
import { Router } from "next/router";
import { UserProvider } from "@auth0/nextjs-auth0/client";
import { SWR_OPTIONS } from "../src/constants/swr";
import { QUINE_APP_VERSION } from "../src/constants/common";
import withTheme from "../src/containers/withTheme";
import withUserContext, {
  useUserContext,
} from "../src/containers/withUserContext";
import SEO from "../src/components/SEO";
import { apiRoutes } from "../src/routes";
import isDev from "../src/utils/isDev";
import { AppPropsWithLayout } from "../src/types";
// import isMobile from "../src/utils/isMobile";
import { useVersionCheck } from "../src/hooks/api/appVersion";
import ToastContainer from "../src/components/Toast";
import { whitelistCheck } from "../src/utils/whitelistCodeCheck";
import LoggedOutOverlay from "../src/components/AuthCallback/LoggedOutOverlay";
import TermsAndConditionsModalWrapper from "../src/components/Modal/TermsAndContidionsModal/TermsAndConditionsModalWrapper";

Router.events.on("routeChangeComplete", (url: string, { shallow }) => {
  if (!shallow) {
    document
      .querySelector("body")
      ?.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }
});

function App({ Component, pageProps, router }: AppPropsWithLayout) {
  const { shouldShowLoggedOutOverlay } = useUserContext();
  useVersionCheck();
  useEffect(() => {
    const versionString = `Quira ${
      isDev() ? "development version" : `v${QUINE_APP_VERSION}`
    }`;

    console.log(`%c${versionString}`, "font-weight: bold;");

    whitelistCheck();
  }, []);

  const getLayout =
    Component.getLayout || ((page: React.ReactElement) => <>{page}</>);

  return (
    <UserProvider loginUrl={apiRoutes.AUTH_LOGIN}>
      {getLayout(
        <SWRConfig value={SWR_OPTIONS}>
          <SEO title="This was Quira ♥️" />
          <Script strategy="lazyOnload" id="help-scout-script" />
          <ToastContainer />
          <Component {...pageProps} />
        </SWRConfig>
      )}
      {shouldShowLoggedOutOverlay && <LoggedOutOverlay />}
      <TermsAndConditionsModalWrapper />
    </UserProvider>
  );
}

export default withTheme(withUserContext(App));
